// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__zc3Bm","consentsList":"PatientConsents_consentsList__3iwyX","consentsListEmpty":"PatientConsents_consentsListEmpty__1eQs2"};